
import { Component, Prop, Vue } from 'vue-property-decorator'
import { type OpenMiniProgramOptionType, openMiniProgram } from '@xt/client/utils/mini'

export type WxImgPopOptionType = {
  title: string
  subTitle: string
  qrcodeUrl: string
  scanTip: string
  openMiniProgramOption: OpenMiniProgramOptionType
}

@Component({
  components: {}
})
export default class WxImgPop extends Vue {
  visible: boolean = false
  dataSource: {
    title: string
    subTitle: string
    qrcodeUrl: string
    scanTip: string
  } = {
    title: '',
    subTitle: '',
    qrcodeUrl: '',
    scanTip: ''
  }
  openMiniProgramOption: OpenMiniProgramOptionType = {
    miniProgrmType: 'uc'
  }

  // 打开弹窗，暴露给外部组件使用
  openPop(option: WxImgPopOptionType) {
    const { title, subTitle, qrcodeUrl, scanTip, openMiniProgramOption } = option

    this.dataSource = {
      title,
      subTitle,
      qrcodeUrl,
      scanTip
    }
    this.openMiniProgramOption = {
      ...openMiniProgramOption
    }
    this.visible = true
  }

  // 关闭弹窗
  hidePop() {
    this.visible = false
  }

  async handleOpenPCMini() {
    const { miniProgrmType, path, query } = this.openMiniProgramOption
    try {
      const { success, reason } = await openMiniProgram(miniProgrmType, path ?? '', query)
      if (!success) {
        this.$message.error(reason || '打开小程序失败')
      }
    } catch (e) {
      this.$message.error('系统错误')
    }
  }
  created() {}
}
